/* example
  new Modal({
      openButton      : '.js-modal-open',
      closeButton     : '.js-modal-close',
      wrapper         : '.modal',
      respond_selector: '.modal .form-respond',
      autoOpen        : true,
      cookieName      : 'newsletter'
      expirationLink  : "newsletter/?nm=confirmed&nk=4-554dd30c82"
      openClass       : 'is-active'                                 // optional - default 'is-open'
      fillInput       : 'data-department',                          // optional
      inputId         : '#department'                               // optional
  });
*/

export default class Modal {
  constructor(args) {
    this.wrapper = document.querySelectorAll(".modal");
    this.openButton = document.querySelectorAll(args.openButton);
    this.closeButton = document.querySelectorAll(args.closeButton);
    this.openClass = args.openClass ? args.openClass : "is-active";

    if (this.wrapper.length > 0) {
      this.bindEvents();
    }
  }
  bindEvents() {
    this.openButton.forEach((item) => {
      item.addEventListener("click", () => {
        console.log(item.dataset);
        const modal = document.getElementById(item.dataset.id);
        this.showModal(modal);
      });
    });

    this.closeButton.forEach((item) => {
      item.addEventListener("click", () => {
        const modal = document.getElementById(item.dataset.id);
        this.hideModal(modal);
      });
    });
  }

  autoOpen(modal, openDelay) {
    setTimeout(() => {
      this.showModal(modal);
    }, openDelay);
  }

  showModal(modal) {
    modal.classList.add(this.openClass);
  }

  hideModal(modal) {
    modal.classList.remove(this.openClass);
    if (modal.dataset.cookie !== undefined && parseInt(modal.dataset.expire) !== 0) {
      this.setCookie(modal.dataset.cookie, modal.dataset.expire);
    }
  }
}
